module.exports = __webpack_public_path__ + "img/sticky_note_2.1b07b9fd.svg";